// <cart-drawer>: slides the bag in from the right. Opens on [data-open-cart] clicks and after anything is added.

import { openOverlay } from '@theme/utils';

class CartDrawer extends HTMLElement {
  connectedCallback() {
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-open-cart]');
      if (!opener) return;
      event.preventDefault();
      this.open();
    });
    document.addEventListener('cart:changed', (event) => {
      if (event.detail?.source === 'add') {
        const status = this.querySelector('[data-cart-confirmation]');
        status.hidden = false;
        status.textContent = '✓ Added to your bag. Choose your day and time.';
        this.open();
      }
    });
    this.querySelectorAll('[data-close-cart]').forEach((button) => button.addEventListener('click', () => this.close?.()));
  }

  open() {
    const panel = this.querySelector('.drawer');
    if (panel.classList.contains('is-open')) return;
    this.close = openOverlay(panel, { onClose: () => { this.close = null; } });
  }
}

customElements.define('cart-drawer', CartDrawer);
